<div class="card">
    <div class="card-header d-flex justify-content-between align-items-start">
        <h4>{{'ABSENCES_REQUEST' | translate}}</h4>
        <a routerLink="/dashboard/absence/requested-list">{{'VIEW_ALL_FEMALE'|translate}}</a>
    </div>
    <div class="card-body">
        <div *ngIf="absences?.length < 1">{{'NOT_ONE_ABSENCE_REQUEST' | translate}}</div>
        <div *ngFor="let absence of absences" class="row mb-1">
            <div class="col-12">
                <a routerLink="/dashboard/absence/requested-list" [queryParams]="{id: absence.id}" [ngbTooltip]="'VIEW_ABSENCE' | translate">{{absence.employee.complete_name}}</a>
                <span class="badge badge-info ml-05">{{absence.type.category | titlecase}}</span>
                <span class="badge badge-warning ml-05">{{"PENDING" | translate}}</span>
                <div class="d-flex justify-content-between font-small-2 mt-025">
                    <span>{{"FROM" | translate}} {{_utilService.formatDate(absence.from, absence.type.category === 'permesso' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY')}}
                    </span>
                    <span>{{"TO" | translate}} {{_utilService.formatDate(absence.to, absence.type.category === 'permesso' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY')}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
